<template>
  <div class="select-content">
    <h3 class="text-align-center">Pagos en confirmación</h3>
    <div class="related-transactions">
      <div
        v-for="(transaction, i) in relatedTransactions"
        :id="`related-transaction-${ i }`"
        :key="transaction._id"
        class="card-item shadowless pending-transaction-item transition-slow"
        :class="extendedTransaction._id === transaction._id ? 'extended' : ''">
        <div class="transaction-head">
          <div class="transaction-head-info payment-title">
            <span class="header-payment-title">Pago {{ i + 1 }}</span>
          </div>
          <div class="transaction-head-info payment-date">
            <span
              class="header-title"
              :class="extendedTransaction._id !== transaction._id ? 'hidden' : ''">
              Fecha:
            </span>
            <span class="header-value">{{ dateFormat(transaction.createdAt) }}</span>
          </div>
          <div
            class="transaction-head-info payment-provider"
            :class="extendedTransaction._id !== transaction._id ? 'hidden' : ''">
            <span class="header-title">Medio de pago:</span>
            <span
              class="header-value">
              {{ paymentProviders.find(x => x.slug === transaction.provider).name }}
            </span>
          </div>
          <div class="transaction-head-info payment-id" :class="extendedTransaction._id !== transaction._id ? 'hidden' : ''">
            <span class="header-title">Id de transacción:</span>
            <span class="header-value">{{ transaction._id }}</span>
          </div>
          <div class="transaction-head-info payment-details">
            <a
              :id="`extend-related-transaction-${ i }`"
              href="#"
              @click="showExtendedTransaction(transaction)">
              <span
                class="fa"
                :class="extendedTransaction._id === transaction._id ? 'fa-minus-circle' : 'fa-plus-circle'" />
            </a>
          </div>
        </div>
        <RelatedTransaction
          v-if="extendedTransaction._id === transaction._id"
          :transaction="extendedTransaction"
          :payment-providers="paymentProviders"
          :display-cancel-button="cancelRelatedTransactionButton"
          @open-cancel-transaction-modal="$emit('open-cancel-transaction-modal', $event)" />
      </div>
    </div>
  </div>
</template>
<script>
import RelatedTransaction from '@/ui/components/internal/pay-here/RelatedTransaction.vue';
import { dateToFormatedString } from '@/infrastructure/date';

export default {
  components: { RelatedTransaction },
  props: ['relatedTransactions', 'paymentProviders', 'cancelRelatedTransactionButton'],
  data() {
    return {
      extendedTransaction: {}
    };
  },
  methods: {
    dateFormat: date => dateToFormatedString(date, 'DD/MM/YYYY'),
    showExtendedTransaction(transaction) {
      if (this.extendedTransaction._id === transaction._id) {
        this.extendedTransaction = {};
      } else {
        this.extendedTransaction = transaction;
      }
    }
  }
};
</script>
<style scoped>
.select-content {
  overflow: inherit;
}
.related-transactions {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  width: 100%;
}
.related-transactions .pending-transaction-item {
  width: min-content;
  padding: 2% 3%;
  margin: 0.7rem 1rem;
  border-radius: 2rem;
}
.related-transactions .pending-transaction-item.extended {
  width: 95%;
}
.pending-transaction-item div.transaction-head {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.4rem 0.7rem;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  padding: 3% 5%;
  background-color: none;
  color: var(--primary);
}
.transaction-head .transaction-head-info {
  display: flex;
  flex-flow: row wrap;
  gap: 0.1rem 0.5rem;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
}
.transaction-head span.header-value {
  color: #4a4a4a;
  font-size: 0.9rem;
  font-weight: 300;
}
.transaction-head .transaction-head-info.hidden,
.header-title.hidden {
  display: none;
}
.transaction-head span.header-payment-title {
  width: max-content;
  font-size: 1.2rem;
  font-weight: 600;
}
@media (max-width: 1080px) {
  .pending-transaction-item div.transaction-head {
    flex-flow: column nowrap;
    align-items: center;
    justify-content: space-around;
  }
}
@media (max-width: 550px) {
  .transaction-head span.header-payment-title {
    font-size: 0.9rem;
    font-weight: 600;
  }
  .transaction-head-info span.header-title,
  .transaction-head-info span.header-value {
    font-size: 0.75rem;
  }
}
</style>
